/* @flow */

import {combineReducers} from 'redux';

import {TinyIntroduction, type TinyIntroState} from './auth';
import {connectedFormsReducer, type ConnectedFormsState} from './connected-forms';
import {creatorReducer, type CreatorState} from './creator';
import {
    emailComposerReducer,
    type EmailComposerState,
    emailReplyReducer,
    type EmailReplyState,
} from './email';
import {
    visitorsSidebarReducer,
    type VisitorsSidebarState,
} from './email-marketing/visitors/visitors-sidebar';
import {glossaryReducer, type GlossaryState} from './glossary/redux';
import {
    chatReducer,
    type ChatState,
    smsReducer,
    type SMSState,
    facebookReducer,
    type FacebookState,
    instagramReducer,
    type InstagramState,
    chatbotReducer,
    type ChatbotState,
    whatsappReducer,
    type WhatsAppState,
} from './inbox/dashboard/report';
import {limitsReducer, type LimitsState} from './limits';
import {messagesReducer, type MessagesState} from './messages';
import {onboardingReducer, type OnboardingState} from './onboarding/onboarding-checklist/redux';
import {openableModalsReducer, type OpenableModalsState} from './openable-modals';
import {peopleIqReducer, type PeopleIqState} from './people-iq/redux';
import {
    engagementLeadsReducer,
    engagementSalesReducer,
    widgetOpensReducer,
    completedActionsReducer,
    type EngagementLeadsState,
    type EngagementSalesState,
    type WidgetOpensState,
    type CompletedActionsState,
} from './reports/engagement';
import {SalesAutomationUi, type SalesAutomationUiState} from './sales-automation';
import {sidebarReducer, type SidebarState} from './sidebar/sidebar-reducer';
import {tasksReducer, type CreatorTasksState} from './tasks';

export type UiState = {
    creator: CreatorState,
    tasks: CreatorTasksState,
    salesAutomation: SalesAutomationUiState,
    tinyIntroduction: TinyIntroState,
    sidebar: SidebarState,
    emailComposer: EmailComposerState,
    emailReply: EmailReplyState,
    messages: MessagesState,
    connectedForms: ConnectedFormsState,
    openableModals: OpenableModalsState,
    visitorsSidebar: VisitorsSidebarState,
    limits: LimitsState,
    glossary: GlossaryState,
    onboarding: OnboardingState,
    peopleIq: PeopleIqState,
    chat: ChatState,
    sms: SMSState,
    facebook: FacebookState,
    instagram: InstagramState,
    chatbot: ChatbotState,
    whatsapp: WhatsAppState,
    engagementLeads: EngagementLeadsState,
    engagementSales: EngagementSalesState,
    widgetOpens: WidgetOpensState,
    completedActions: CompletedActionsState,
};

// $FlowFixMe upgrading Flow to v0.92.1 on web
export const uiReducer = combineReducers({
    creator: creatorReducer,
    tasks: tasksReducer,
    salesAutomation: SalesAutomationUi.uiReducer,
    tinyIntroduction: TinyIntroduction.tinyIntroReducer,
    sidebar: sidebarReducer,
    emailComposer: emailComposerReducer,
    emailReply: emailReplyReducer,
    messages: messagesReducer,
    connectedForms: connectedFormsReducer,
    openableModals: openableModalsReducer,
    visitorsSidebar: visitorsSidebarReducer,
    limits: limitsReducer,
    glossary: glossaryReducer,
    onboarding: onboardingReducer,
    peopleIq: peopleIqReducer,
    chat: chatReducer,
    sms: smsReducer,
    facebook: facebookReducer,
    instagram: instagramReducer,
    chatbot: chatbotReducer,
    whatsapp: whatsappReducer,
    engagementLeads: engagementLeadsReducer,
    engagementSales: engagementSalesReducer,
    widgetOpens: widgetOpensReducer,
    completedActions: completedActionsReducer,
});
